export const BANNED = 'support'
export const HIJACKED = 'hijacked'
export const SPOILED = 'unblock'
